import SideBox from '#src/client/common/boxes/SideBox.jsx';
import Details from '#src/client/common/elements/Details.jsx';
import Items from '#src/client/common/layout/Items.jsx';
import isEmpty from '#src/client/common/utils/isEmpty.js';
import { createEffect, createSignal } from 'solid-js';
import style from '#src/client/common/errors/RenderingErrorModal.module.css';
import LabeledItem from '#src/client/common/displayers/LabeledItem.jsx';
import errorToObj from '#src/client/common/utils/errorToObj.js';
import { genRequest } from '#src/client/common/utils/browser/fetchHelper.js';
import cleanMetaForErrorReporting from '#src/client/common/utils/cleanMetaForErrorReporting.js';
import Button from '#src/client/common/interactive/Button.jsx';
import makeJavascriptReadable from '#src/client/common/utils/makeJavascriptReadable.js';

export default function RenderingErrorModal(props) {
    let dialogRef;

    const [hasSentErrorReport, setHasSentErrorReport] = createSignal(false);

    createEffect(() => {
        if (!dialogRef.open) {
            dialogRef.showModal();
        }
    });

    const sendErrorReport = async () => {
        const { message, name, code, stack, details } = props.state ?? {};

        let updatedStack = null;
        if (stack) {
            updatedStack = stack.replace('\\n', '\n');
        }

        const [errors] = await genRequest({
            url: '/report-error/api/',
            body: {
                url: document.location.href,
                error: {
                    message: message ?? null,
                    name: name ?? null,
                    code: code ?? null,
                    details: details ?? null,
                    stack: updatedStack ?? null,
                },
                meta: cleanMetaForErrorReporting(props.meta ?? {}),
            },
        });

        // If submitted successfully, hide the button.
        setHasSentErrorReport(isEmpty(errors));
    };

    return (
        <dialog ref={dialogRef} class={style.modal}>
            <Items>
                <h2>Rendering Error Occurred</h2>

                <SideBox borderColor="negative" class="preLine">{props.state.message}</SideBox>

                <p>Sorry about that. If you want to submit an error report, click the button inside Details below, then contact us and tell us what happened.</p>

                <Details label="Details">
                    <Items class={style.modalScrollBox}>
                        <Items size="medium">
                            <For each={Object.keys(errorToObj(props.state))}>
                                {(errorKey) => (
                                    <LabeledItem label={errorKey}>
                                        <p class="preWrap">{makeJavascriptReadable(props.state[errorKey])}</p>
                                    </LabeledItem>
                                )}
                            </For>
                        </Items>

                        <Show when={!hasSentErrorReport()}>
                            <Button onClick={sendErrorReport} color="warning" class="flexStart">Send Error Report</Button>
                        </Show>
                    </Items>
                </Details>

                <p><a href="/">Return to Login</a></p>
            </Items>
        </dialog>
    );
}